import React, { Component } from "react";
import {
  NumericInput,
  Radio,
  RadioGroup,
  InputGroup,
  Label,
  Checkbox,
  TextArea
} from "@blueprintjs/core";
import Repeat from "react-repeat-component";
import { Row, Col } from "react-flexbox-grid";

class FormCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberOfQuestions: this.props.questions.length,
      questions: this.props.questions
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.questions !== this.state.questions) {
      this.setState({
        questions: this.props.questions,
        numberOfQuestions: this.props.questions.length
      });
    }
  }
  handleNumChange = num => {
    var questions = this.state.questions;
    while (num < questions.length) {
      questions.pop();
    }
    while (num > questions.length) {
      questions.push({ type: "", options: [""], isRequired: false });
    }
    this.setState({ numberOfQuestions: num });
  };
  handleTypeChange = (event, i) => {
    var questions = this.state.questions;
    questions[i].type = event.target.value;
    this.setState({
      questions: questions
    });
    this.props.getQuestions(this.state.questions);
  };
  handleQuestionTextChange = (event, i) => {
    var questions = this.state.questions;
    questions[i].text = event.target.value.trim();
    this.setState({ questions: questions });
    this.props.getQuestions(this.state.questions);
  };
  handleOptionsChange = (num, i) => {
    var questions = this.state.questions;
    while (num < questions[i].options.length) {
      questions[i].options.pop();
    }
    while (num > questions[i].options.length) {
      questions[i].options.push("");
    }
    this.setState({ questions: questions });
    this.props.getQuestions(this.state.questions);
  };
  handleOptionTextChange = (event, i, j) => {
    var questions = this.state.questions;
    questions[i].options[j] = event.target.value.trim();
    this.setState({ questions: questions });
    this.props.getQuestions(this.state.questions);
  };
  handleRequiredChange = (event, i) => {
    var questions = this.state.questions;
    questions[i].isRequired = event.target.checked;
    this.setState({ questions: questions });
    this.props.getQuestions(this.state.questions);
  };
  render() {
    return (
      <Col>
        <NumericInput
          value={this.state.numberOfQuestions}
          buttonPosition="right"
          onValueChange={this.handleNumChange}
          allowNumericCharactersOnly={true}
          min={0}
        />
        <Repeat times={this.state.numberOfQuestions}>
          {i => (
            <Row id={"main_row_" + i}>
              <Col xs id={"main_col_" + i}>
                <RadioGroup
                  id={"main_radio_group" + i}
                  label="Type"
                  onChange={event => this.handleTypeChange(event, i)}
                  selectedValue={this.state.questions[i].type}
                >
                  <Radio label="Multiple Choice" value="mcq"></Radio>
                  <Radio label="Checkbox" value="cbq"></Radio>
                  <Radio label="Short Text" value="text"></Radio>
                  <Radio label="Long Text" value="long_text"></Radio>
                </RadioGroup>
              </Col>
              {this.state.questions[i].type === "mcq" ? (
                <div id={i}>
                  <Row>
                    <Col xs>
                      <Checkbox
                        inline={true}
                        checked={this.state.questions[i].isRequired}
                        label="Required?"
                        onChange={event => this.handleRequiredChange(event, i)}
                      ></Checkbox>
                    </Col>
                    <Col xs>
                      <Label>
                        Question Text
                        <TextArea
                          growVertically={true}
                          defaultValue={this.state.questions[i].text}
                          onChange={event =>
                            this.handleQuestionTextChange(event, i)
                          }
                        ></TextArea>
                      </Label>
                    </Col>
                    <Col xs>
                      <Label>
                        Number of options
                        <NumericInput
                          value={this.state.questions[i].options.length}
                          buttonPosition="right"
                          onValueChange={num =>
                            this.handleOptionsChange(num, i)
                          }
                          allowNumericCharactersOnly={true}
                          min={1}
                        />
                      </Label>
                    </Col>
                  </Row>
                  <Col xs>
                    <Repeat times={this.state.questions[i].options.length}>
                      {j => (
                        <Label>
                          Option {j + 1}:
                          <InputGroup
                            defaultValue={this.state.questions[i].options[j]}
                            onChange={event =>
                              this.handleOptionTextChange(event, i, j)
                            }
                          ></InputGroup>
                        </Label>
                      )}
                    </Repeat>
                  </Col>
                </div>
              ) : null}
              {this.state.questions[i].type === "cbq" ? (
                <div>
                  <Row>
                    <Col xs>
                      <Checkbox
                        inline={true}
                        checked={this.state.questions[i].isRequired}
                        label="Required?"
                        onChange={event => this.handleRequiredChange(event, i)}
                      ></Checkbox>
                    </Col>
                    <Col xs>
                      <Label>
                        Question Text
                        <TextArea
                          growVertically={true}
                          defaultValue={this.state.questions[i].text}
                          onChange={event =>
                            this.handleQuestionTextChange(event, i)
                          }
                        ></TextArea>
                      </Label>
                    </Col>
                    <Col xs>
                      <Label>
                        Number of options
                        <NumericInput
                          value={this.state.questions[i].options.length}
                          buttonPosition="right"
                          onValueChange={num =>
                            this.handleOptionsChange(num, i)
                          }
                          allowNumericCharactersOnly={true}
                          min={1}
                        />
                      </Label>
                    </Col>
                  </Row>
                  <Col xs>
                    <Repeat times={this.state.questions[i].options.length}>
                      {j => (
                        <Label>
                          Option {j + 1}:
                          <InputGroup
                            defaultValue={this.state.questions[i].options[j]}
                            onChange={event =>
                              this.handleOptionTextChange(event, i, j)
                            }
                          ></InputGroup>
                        </Label>
                      )}
                    </Repeat>
                  </Col>
                </div>
              ) : null}
              {this.state.questions[i].type === "text" ||
              this.state.questions[i].type === "long_text" ? (
                <div>
                  <Row>
                    <Col xs>
                      <Checkbox
                        inline={true}
                        checked={this.state.questions[i].isRequired}
                        label="Required?"
                        onChange={event => this.handleRequiredChange(event, i)}
                      ></Checkbox>
                    </Col>
                    <Col xs>
                      <Label>
                        Question Text
                        <TextArea
                          growVertically={true}
                          defaultValue={this.state.questions[i].text}
                          onChange={event =>
                            this.handleQuestionTextChange(event, i)
                          }
                        ></TextArea>
                      </Label>
                    </Col>
                  </Row>
                </div>
              ) : null}
            </Row>
          )}
        </Repeat>
      </Col>
    );
  }
}
export default FormCreation;
